// extracted by mini-css-extract-plugin
export default {"menuItem":"driversTableCustomCells_menuItem__vlhV7","menuItemIcon":"driversTableCustomCells_menuItemIcon__Rdmh+"};